<template>
  <ul v-if="networks?.length > 1" class="t-share flex" :class="getClasses()">
    <li v-for="(network, index) in networks" :key="index">
      <UButton
        :color="'neutral'"
        :variant="variant === 'buttons' ? 'ghost' : 'subtle'"
        size="md"
        type="button"
        :label="network.title"
        :aria-label="network.title"
        :icon="iconNameByKind[network.kind]"
        @click="onClick(network)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import {
  type networkType,
  type networkCopyType,
  type networkWhatsappType,
  type propsInterface,
  iconNameByKind,
} from './constants'

const props = withDefaults(defineProps<propsInterface>(), {
  variant: 'buttons',
})

const { isIos } = useDevice()

const getClasses = () => {
  if (props.variant === 'buttons') {
    return 'flex-wrap gap-5 flex-col'
  } else {
    return 'flex-col gap-4 md:flex-row'
  }
}

const onClick = (network: networkType) => {
  if ('copy' === network.kind) {
    onClickCopy(network)
  } else if ('whatsapp' === network.kind) {
    onClickWhatsapp(network)
  }
}

const onClickCopy = async (networkCopy: networkCopyType) => {
  if (typeof window.ERAndroid !== 'undefined') {
    window.ERAndroid.copyToClipboard(networkCopy.url)
  } else {
    await navigator.clipboard.writeText(networkCopy.url)
  }

  window.alert(networkCopy.copiedText)
}

const onClickWhatsapp = (networkWhatsapp: networkWhatsappType) => {
  // Use URL API for cleaner construction and proper encoding
  const whatsappUrl = new URL('https://api.whatsapp.com/send')
  const messageText =
    `${networkWhatsapp.message || ''} ${networkWhatsapp.url}`.trim()
  whatsappUrl.searchParams.set('text', messageText)

  const href = whatsappUrl.href

  // Handle iOS webview - use native bridge to open external URLs
  if (isIos && window.webkit?.messageHandlers?.openUrl) {
    window.webkit.messageHandlers.openUrl.postMessage(href)
    return
  }

  // Fallback for regular browsers and Android webview (already working)
  window.open(
    href,
    'Please wait...',
    'scrollbars=1,status=0,menubar=0,personalbar=0,location=1,height=448,width=550,top=140,left=200',
  )
}
</script>
